// extracted by mini-css-extract-plugin
module.exports = {"buttonMarkAll":"Notifications_buttonMarkAll__3fzpj"};